import Chip from "@material-ui/core/Chip";
import Popover from "@material-ui/core/Popover";
import {MultipleSubscriptionType} from "./MultipleSubscriptionType";
import React from "react";
import {useTranslation} from "react-i18next";
import {useTheme} from "@material-ui/core";
import {ChipBackgroundColors, ChipTextColors} from "../../../../layout/_constants";

export const SubscriptionType = (props: any) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const {id, subscriptions, organizationId, organizationUnitId, onSubscriptionRemoved} = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const popOverId = open ? 'simple-popover' : undefined;

    if (subscriptions.length === 0) {
        return <Chip color={'primary'}
                     style={{backgroundColor: ChipBackgroundColors.Disabled, color: ChipTextColors.Disabled}}
                     label={t(`Subscription.Tags.NoSubscription`)}/>;
    }

    if (subscriptions.length === 1) {
        if (subscriptions[0].source === 'OrganizationUnit' && subscriptions[0].isExpired) {
            return <Chip color={'primary'}
                         style={{backgroundColor: ChipBackgroundColors.Expired}}
                         label={t(`Subscription.Tags.Expired`)}/>;
        }
        return <Chip style={{backgroundColor: ChipBackgroundColors.Default, color: ChipTextColors.Default}}
                     label={t(`_Shared.SubscriptionType.${subscriptions[0].type}`)}/>;
    }

    return (
        <div>
            <Chip color={'primary'}
                  style={{backgroundColor: theme.palette.primary.main}}
                  label={t('Subscription.Tags.Multiple')}
                  onClick={handleClick}
                  aria-describedby={popOverId}/>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}>
                <MultipleSubscriptionType subscriptions={subscriptions}
                                          organizationId={organizationId}
                                          organizationUnitId={organizationUnitId}
                                          onSubscriptionRemoved={onSubscriptionRemoved}/>
            </Popover>
        </div>
    )
};
